import {convertCoordinates} from '@/api/util-coordinates';

class GreenWayApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    id,
    idVia,
    name,
    description,
    route,
    province,
    region,
    poi,
    leisure,
    access,
    cx,
    cy,
    // visible,
  }) {
    return {
      id,
      idVia,
      name,
      description,
      route,
      routeSteps: route.split('-'),
      province,
      region,
      poi,
      leisure,
      access,
      coordinates: convertCoordinates(cx, cy),
      visible: false, // TODO: Quitar cuando esté en la api
    };
  }
}

export default GreenWayApiResponseModel;
